import { useEffect } from "react";

/* Torna as rotas /mobile-app instaláveis como PWA SEM tocar o index.html global:
   injeta o manifest próprio (start_url /mobile-app, ícones ConversAI) e troca o
   apple-touch-icon do template (vermelho) pelo ícone azul ConversAI.
   Só roda nas rotas mobile (ChatMobile e LoginMobile chamam o hook) — as demais
   rotas do dash seguem sem manifest, como sempre foram.
   Obs.: não restauramos as tags ao desmontar de propósito — o fluxo mobile é
   terminal (não há navegação pro dash desktop a partir dele). */
export const usePwaMobile = () => {
  useEffect(() => {
    // Manifest (Chrome/Android lê na hora do "Instalar app")
    let manifest = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (!manifest) {
      manifest = document.createElement("link");
      manifest.rel = "manifest";
      document.head.appendChild(manifest);
    }
    manifest.href = "/manifest-mobile.json";

    // apple-touch-icon (iOS lê na hora do "Adicionar à Tela de Início")
    let apple = document.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
    if (!apple) {
      apple = document.createElement("link");
      apple.rel = "apple-touch-icon";
      document.head.appendChild(apple);
    }
    apple.href = "/icons/apple-touch-icon.png";

    // Cor da barra do navegador no Android (verde do chat, não o teal do template)
    const theme = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    if (theme) theme.content = "#008069";

    // Service worker do push (public/cmob-sw.js): registra 1x; escopo /mobile-app.
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/cmob-sw.js").catch(() => {
        /* sem SW = sem push; o app continua funcionando normal */
      });
    }
  }, []);
};

export default usePwaMobile;
